var feedElement = document.getElementsByClassName("sidebar-element--twitter")[0];

if (feedElement && is_mobile()) {

  // add fixed class
  feedElement.classList.add("fixed");

  // change element title
  var title = feedElement.getElementsByClassName("sidebar-element__title")[0].innerHTML = '<span><button class="participate js-participate">Osallistu keskusteluun</button></span>';

  // listen for clicks for title button
  document.addEventListener('click', function (e) {
    if (typeof e.target.classList !== 'undefined' && e.target.classList.contains('js-participate')) {
      // add class to body
      document.body.classList.toggle("feed-open");
    }
  });

}

function is_mobile() {
  screen_w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
  if(screen_w < 770) {
    return true;
  }
  return false;
}
